import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { InstructorCard } from "@/components/InstructorCard";
import { Input } from "@/components/ui/input";
import { Loader2, Search, Users } from "lucide-react";

export default function BrowseInstructors() {
  const [instructors, setInstructors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/instructors").then(({ data }) => setInstructors(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = instructors.filter((i) =>
    i.name.toLowerCase().includes(q.toLowerCase()) || (i.location || "").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <h1 className="font-heading font-extrabold text-3xl text-arctic-secondary tracking-tight" data-testid="browse-title">Find your instructor</h1>
        <p className="text-muted-foreground mt-1">Browse expert instructors and book your next lesson.</p>

        <div className="relative mt-6 max-w-md">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name or area..." className="pl-9 rounded-full" data-testid="instructor-search" />
        </div>

        {loading ? (
          <div className="flex justify-center py-16"><Loader2 className="w-8 h-8 animate-spin text-arctic-primary" /></div>
        ) : filtered.length === 0 ? (
          <div className="text-center py-16 text-muted-foreground"><Users className="w-10 h-10 mx-auto mb-3 opacity-40" /><p>No instructors found.</p></div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8" data-testid="instructor-list">
            {filtered.map((i) => <InstructorCard key={i.user_id} instructor={i} />)}
          </div>
        )}
      </main>
    </div>
  );
}
